// React
import React from "react";
import classNames from "classnames";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./AuthContainer.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
const AuthContainer = (props) => {
    return (React.createElement("div", { className: classNames(styles.container, props.isLarge && styles.containerLarge) },
        props.children,
        React.createElement("div", { className: styles.contactText },
            "Need help? Contact our call centre on ",
            callCentreNumberText)));
};
export default AuthContainer;
